import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const BatchList = lazy(() => import('../system-admin/batch/BatchList'));
const SystemMain = lazy(() => import('../system-admin/SystemMain'));
const SystemDates = lazy(
  () => import('../system-admin/system-dates/SystemDates')
);
const Batch = lazy(() => import('../system-admin/batch/Batch'));

const YearlyMnFaProcess = lazy(
  () => import('../system-admin/batch/YearlyMnFAProcess')
);
const EndOfSeasonServiceProcess = lazy(
  () => import('../system-admin/batch/EndOfSeasonServiceProcess')
);
const EmailUtility = lazy(() => import('../system-admin/email/EmailUtility'));

export default [
  {
    id: NavConfig.groupConfigs.SYSTEM.id,
    path: NavConfig.groupConfigs.SYSTEM.to,
    element: (
      <SystemMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </SystemMain>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.SYS_SYSTEM_DATES.to} />,
      },
      {
        id: NavConfig.linkConfigs.SYS_BATCHES.id,
        path: NavConfig.linkConfigs.SYS_BATCHES.to,
        element: <BatchList />,
      },
      {
        id: NavConfig.linkConfigs.SYS_BATCH_UTILITY.id,
        path: NavConfig.linkConfigs.SYS_BATCH_UTILITY.to,
        element: <Batch />,
      },
      {
        id: NavConfig.linkConfigs.SYS_MNFA_PROCESS.id,
        path: NavConfig.linkConfigs.SYS_MNFA_PROCESS.to,
        element: <YearlyMnFaProcess />,
      },
      {
        id: NavConfig.linkConfigs.SYS_END_OF_SEASON_SERVICE_PROCESS.id,
        path: NavConfig.linkConfigs.SYS_END_OF_SEASON_SERVICE_PROCESS.to,
        element: <EndOfSeasonServiceProcess />,
      },
      {
        id: NavConfig.linkConfigs.SYS_SYSTEM_DATES.id,
        path: NavConfig.linkConfigs.SYS_SYSTEM_DATES.to,
        element: <SystemDates />,
      },
      {
        id: NavConfig.linkConfigs.SYS_EMAILS.id,
        path: NavConfig.linkConfigs.SYS_EMAILS.to,
        element: <EmailUtility />,
      },
    ],
  },
];
